import { useEffect } from "react";
import type { Surface } from "../../api/types";
import loginFavicon from "../../assets/login-favicon.webp";

/** The hub sign-in page has one fixed identity, whatever Theme Settings say: this title and
    favicon. Theme Settings apply only once someone is signed in. The portal keeps its own. */
export const LOGIN_TITLE = "Infinity Information Technology Solutions LLC";

export function useHubBranding(surface: Surface): void {
  useEffect(() => {
    if (surface !== "hub") return;
    document.title = LOGIN_TITLE;
    let link = document.querySelector<HTMLLinkElement>("link[rel='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.type = "image/webp";
    link.href = loginFavicon;
  }, [surface]);
}
